define('GameDayCore/GDModel/enums/datasources/DatasourceToEventMap',{
    gumbo: "GUMBO",
    play: "PLAYS",
    players: "PLAYERS",
    game: "GAME",
    boxscore: "BOXSCORE",
    bench: "BENCH",
    linescore: "LINESCORE",
    lineup: "LINEUP",
    scores: "SCORES",
    hitchart: "HITCHART",
    miniscoreboard: "MINISCOREBOARD",
    inning: "INNING",
    playercard: "PLAYER_CARD",
    hotcoldzone: "HOT_COLD_ZONE",
    displayconfig: "DISPLAY_CONFIG",
    jingles: "JINGLES",
    tpl_lib: "TEMPLATES",
    gamecenter: "GAMECENTER",
    video: "VIDEO",
    liveLookin: "LIVE_LOOKIN",
    gdConfig: "GD_CONFIG",
    skin_config: "SKIN_CONFIG",
    timecode: "TIMECODE",
    staticresources: "STATIC_RESOURCES",
    moundball: "MOUNDBALL"
});
